import React from 'react';
import './App.css';
import { Form } from './screens/Form';
import { FichaCadastral } from './screens/FichaCadastral';

declare const document: any;

// document.beyondFormName = 'ficha_cadastral'

function App() {
  return !!document.beyondFormName && document.beyondFormName === 'ficha_cadastral' ? <FichaCadastral /> : <Form />;
}

export default App;
